import { default as SearchAzure } from './SearchAzure';
import { default as SearchNominatim } from './SearchNominatim';
import { default as SearchBings } from './SearchBings';

class AddressSearch {
  constructor(options = {}) {
    const type = (options.type || '').toLowerCase();
    switch (type) {
      case 'azure':
        return new SearchAzure(options);
      case 'bing':
        return new SearchBings(options);
      case 'osm':
      default:
        return new SearchNominatim(options);
    }
  }
}

export default AddressSearch;